import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Grid } from 'semantic-ui-react';
import { push } from 'connected-react-router';
import { EUserGroup, EUserLevels, IProject, IUser } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { appState } from '../redux/selectors';
import { NavBar } from '../components/NavBar';
import { projectsAction } from '../redux/actions';
import { ProjectsListComponent } from '../components/project/ProjectsListComponent';
import { RootState } from '../redux/types';
import { TranslationComponent } from '../components/TranslationComponent';
import { PtwImportModal } from '../components/ptw/PtwImportModal';

interface ProjectsSceneProps extends Component {
  projects: IProject[];
  user: IUser;
  projectsAction: typeof projectsAction;
  push: typeof push;
}

const checkImportPermission = (projects: IProject[], user: IUser) =>
  projects
    .map((project) =>
      project.assignees
        .filter((assignee) => assignee.user._id.toString() === user._id.toString())
        .map((assignee) => assignee.group)
        .some((userGroup) => userGroup === EUserGroup.PQM_DELEGATE)
    )
    .find((permission) => permission === true);

class PProjectsScene extends Component<ProjectsSceneProps> {
  componentDidMount(): void {
    this.props.projectsAction();
  }

  render() {
    const { projects, push, user } = this.props;

    return (
      <React.Fragment>
        <HeaderComponent />
        <NavBar />

        {(user.userLevel === EUserLevels.Admin || checkImportPermission(projects, user)) && (
          <Grid>
            <Grid.Column floated="right">
              <div
                style={{
                  display: 'flex',
                  width: '250px',
                  justifyContent: 'space-evenly',
                  margin: '0 0 0 auto',
                }}
              >
                <PtwImportModal />

                {user.userLevel === EUserLevels.Admin && (
                  <Button primary onClick={() => push('/projects/create')}>
                    <TranslationComponent stringKey={'New Project'} />
                  </Button>
                )}
              </div>
            </Grid.Column>
          </Grid>
        )}
        <ProjectsListComponent projects={projects} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  projects: appState(state).projects,
  user: appState(state).user,
});

export const ProjectsScene = connect(mapStateToProps, { projectsAction, push })(PProjectsScene);
